/** UploadTray.tsx — the one docked upload tray, on every Ballast page. */
export const tray = {
  /** Accessible name of the tray region. */
  'tray.title': 'Uploads',
  /** Header while files are moving. {n} = files still queued or in
   *  flight; the overall percentage sits beside it. */
  'tray.uploadingCount_one': 'Uploading {n} file',
  'tray.uploadingCount_other': 'Uploading {n} files',
  /** Header once everything has landed. */
  'tray.allDone': 'Uploads finished',
  'tray.done': 'Done',
  'tray.failed': 'Failed',
  'tray.retry': 'Retry',
  'tray.pause': 'Pause',
  'tray.resume': 'Resume',
  'tray.cancel': 'Cancel',
  'tray.clear': 'Clear',
  'tray.hide': 'Hide',
  'tray.show': 'Show',
} as const;
